import { useContext, useEffect, useRef } from 'react';
import { useMutation } from '@tanstack/react-query';
import { updateLocation } from '../controllers/notify/notifications';
import { UserContext } from '../context/UserContext';

export const LocationTracker = () => {
  const { userDetails } = useContext(UserContext);
  const token = userDetails?.token;
  const mastodon_id = userDetails?.id;
  const hasRun = useRef(false);

  const mutation = useMutation({ mutationFn: updateLocation });

  useEffect(() => {
    if (!token || !mastodon_id || hasRun.current) return;
    if (!navigator.geolocation) return;
    hasRun.current = true;

    navigator.geolocation.getCurrentPosition(
      (position) => {
        mutation.mutate({
          token,
          mastodon_id,
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      (error) => {
        console.error('LocationTracker: failed to get current position', error);
      },
      { enableHighAccuracy: false, timeout: 10000 }
    );
  }, [token, mastodon_id]);

  return null;
};
